import { ISoilAnalysisLayerViewerFactory, LayerTypeId } from "../../types"
import { INumericValuesViewerOptions, IDatalayerKeyItem, IDatalayerMapInstance, NumericValuesViewer, createValuedColorsProvider } from "../../omnia"

const minZoneValue: number = 0
const maxZoneValue: number = 80

const colors = [
    { Value: 0, Colour: [255, 255, 255] },
    { Value: 0.1, Colour: [255, 83, 255] },
    { Value: 2, Colour: [59, 173, 243] },
    { Value: 10, Colour: [0, 0, 255] },
    { Value: 20, Colour: [255, 255, 0] },
    { Value: 40, Colour: [255, 135, 0] },
    { Value: 80, Colour: [255, 0, 0] },
]

export class PcnViewer extends NumericValuesViewer {

    public static getFactory(name: string, key: string): ISoilAnalysisLayerViewerFactory {

        let colorProvider = createValuedColorsProvider(colors)

        let options: INumericValuesViewerOptions = {
            dataProperty: key,
            colorProvider
        }

        let factory: ISoilAnalysisLayerViewerFactory = {

            typeId: LayerTypeId.PcnAnalysis,
            name,
            key,

            createViewer: (layer) => new PcnViewer(layer, options, name),

            colors

        }

        return factory
    }

    constructor(layer: IDatalayerMapInstance, options: INumericValuesViewerOptions, private name: string) {
        super(layer, options)
    }

    protected setupMinMaxZoneValues() {
        this._minZoneValue = minZoneValue
        this._maxZoneValue = maxZoneValue
    }

    getKey() {
        return this.setupKey(super.getKey())
    }

    protected setupKey(key: { typeKey: IDatalayerKeyItem[], layerKey: IDatalayerKeyItem[] }) {

        const id = `pcn-analysis-${this._dataProperty}`
        const name = "PCN - " + this.name

        return {
            ...key,
            id,
            name,
            numeric: true,
            fixed: false
        }
    }

}
